import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { GALLERY_IMAGES } from './constants'

function ModelGallery() {
  return (
    <div className="ai-sign-in-modal__gallery" aria-hidden="true">
      {GALLERY_IMAGES.map(({ name, src, alt, isTall, isWide, className }) => (
        <div
          key={name}
          className={classnames(
            'ai-sign-in-modal__cell',
            isTall && 'ai-sign-in-modal__cell--tall',
            isWide && 'ai-sign-in-modal__cell--wide',
          )}
        >
          <img className={classnames('ai-sign-in-modal__cell-image', className)} src={src} alt={alt} loading="lazy" />
        </div>
      ))}
    </div>
  )
}

export default ModelGallery
